/* Grafilabel: aanvullende producten toevoegen zonder de pagina te verlaten (15 okt 2026).
   Context 'page' (winkelwagenpagina) laten we bewust gewoon posten: dan ververst de pagina en
   kloppen regels en totalen direct. Overal anders verversen we de winkelwagen in de zijkant. */
(function () {
  if (window.glAanvullendInit) return;
  window.glAanvullendInit = true;

  document.addEventListener('submit', async function (event) {
    var form = event.target.closest && event.target.closest('[data-gl-av-form]');
    if (!form || form.dataset.context === 'page') return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch) return;

    event.preventDefault();
    var button = form.querySelector('.gl-av__add');
    var item = form.closest('.gl-av__item');
    var error = item && item.querySelector('.gl-av__error');
    if (button.getAttribute('aria-disabled') === 'true') return;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('is-loading');
    if (error) { error.hidden = true; error.textContent = ''; }

    var id = Number(form.querySelector('[name="id"]').value);
    var quantity = Number(form.querySelector('[name="quantity"]').value) || 1;
    var addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';

    try {
      var response = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: id, quantity: quantity }],
          sections: drawer.getSectionsToRender().map(function (s) { return s.id; }),
          sections_url: window.location.pathname
        })
      });
      var state = await response.json();
      if (!response.ok || state.status) {
        throw new Error(state.description || state.message || 'Toevoegen is niet gelukt.');
      }
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gl-aanvullend', productVariantId: id, cartData: state });
      }
      drawer.classList.remove('is-empty');
      drawer.renderContents(state);
    } catch (e) {
      if (error) { error.textContent = e.message; error.hidden = false; }
      button.removeAttribute('aria-disabled');
      button.classList.remove('is-loading');
    }
  });
})();
